import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'
import axios from 'axios'
import { Form, Input, Button, Checkbox, Select, TreeSelect, InputNumber, Modal, Pagination, Row, Col, message, Switch } from 'antd'
import BrandSelect from '../../components/BrandSelect'
import MerchantSelect from '../../components/MerchantSelect'
import AttributeValueSelect, { getAggregationsFeatureIds } from '@components/search/AttributeValueSelect'
import { discoverV2Download, discoverV2 } from '../../services/productService'
import { useSearchContext } from '@pages/discovery/context'
import './searchForm.scss'

const Option = Select.Option
const { TreeNode } = TreeSelect

const sortOptions = [
    {
        value: {sortKey: "discount"},
        label: "折扣排序"
    },
    {
        value: {sortKey: "sales"},
        label: "销量排序"
    },                           
    { value: {sortKey: 'metrics.sales1Day'}, label: '最近1天销量排序' },
    { value: {sortKey: 'metrics.sales7Days'}, label: '最近7天销量排序' },
    { value: {sortKey: 'metrics.sales30Days'}, label: '最近30天销量排序' },
    { value: {sortKey: 'metrics.sales90Days'}, label: '最近90天销量排序' },
    {
        label:"口碑榜",
        value: {sortKey: "metrics_praise_products"}
    },
    {
        label:"回购榜",
        value: {sortKey: "metrics.multiPurchaseIndex"}
    },
    {
        label:"按照热度排序",
        value: {sortKey: "metrics.popularScore"}
    },
    {
        label:"按照最新排序",
        value: {sortKey: "recency"}
    },
    {
        label:"按价格(由低到高)",
        value: {sortKey: "promotionSearchInfo.lowBeyondPriceCents", ascending: true},
    },
    {
        label:"按价格(由高到低)",
        value: {sortKey: "promotionSearchInfo.lowBeyondPriceCents", ascending: false},
    },
]

const treeSelect = (children, parentName?: string) => {
    return children && children.length > 0 ? (
        children.map((item) => {
            return (
                <TreeNode
                    value={item.category.id}
                    title={`${item.category.id}-${parentName ? parentName + '-' : ''}${item.category.displayTerm
                        }(${item.category.term})`}
                    key={item.category.id}
                >
                    {item.children &&
                        item.children.length > 0 &&
                        treeSelect(
                            item.children,
                            `${parentName ? parentName + '-' : ''}${item.category.displayTerm
                            }`
                        )}
                </TreeNode>
            )
        })
    ) : null
}

// populate query params to url history
function updateUrlHistory(queryParams: string) {
    try {
        const url = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${queryParams}`
        if (url.length > 2000) {
            // too long, avoid browser url length limit
            message.warn('url too long, prevents query params population from hitting browser limits')
            return
        }
        window.history.pushState({ path: url }, '', url)
    } catch (e) {
        console.error(e)
    }
}

function SearchForm(props) {
    const { queryParams, setQueryParams, setExpandFlag, searchResult, setSearchResult, setSearchLoading } = useSearchContext()
    const { Categories } = props || {}
    const divRef = useRef<any>(null)
    const [pageSize, setPageSize] = useState(15)
    const [pageNo, setPageNo] = useState(1)
    const [showModal, setShowModal] = useState(false)
    const [onlyProduct, setOnlyProduct] = useState(true)
    const [limit, setLimit] = useState(1000)
    const [showSearchParams, setShowSearchParams] = useState(false)
    const invalidate = useRef(true)
    const abortHandler = useRef<any>(null)

    const getParams = (queryParams, isDownload?: boolean) => {
        const { newArrivals, lowRange, highRange, ...rest } = queryParams || {}
        const _qps = Object.assign({}, rest)
        if (lowRange || highRange) {
            _qps['prs'] = `c${lowRange || ''}-${highRange || ''}`
        }
        _qps['f'] = pageNo > 0 ? (pageNo - 1) * pageSize : 0
        _qps['t'] = pageNo > 0 ? pageNo * pageSize : pageSize
        _qps['area_purchase'] = false
        _qps['_rd'] = true
        if (isDownload) {
            _qps.pidOnly = onlyProduct
            _qps.limit = limit
        }
        Object.keys(_qps).forEach(item => {
            if (Array.isArray(_qps[item]) && _qps[item].length === 0) {
                delete _qps[item]
            } else if (!_qps[item]) {
                delete _qps[item]
            }
        })
        return _qps
    }

    const searchProduct = (queryParams) => {
        if (abortHandler.current) {
            // abort the previous request first
            abortHandler?.current?.cancel()
        }
        const params = getParams(queryParams)
        abortHandler.current = axios.CancelToken.source()
        setSearchLoading(true)
        discoverV2(params, abortHandler.current)
            .then(res => {
                setSearchLoading(false)
                if (res.data) {
                    console.log(res.data)
                    setSearchResult(res.data)
                }
            })
            .catch(error => {
                console.error(error)
                message.error('Failed to search products!')
                setSearchLoading(false)
            })
    }

    const initParams = () => {
        if (window?.location?.search?.length) {
            let _queryParams = {}
            try {
                // remove ?
                const params = qs.parse(window.location.search.substring(1))
                if (typeof params.sq === 'string') {
                    _queryParams = decodeURIComponent(params.sq)
                    _queryParams = qs.parse(_queryParams)
                } else {
                    _queryParams = params
                }
            } catch(e) {}
            if (!_queryParams || Object.keys(_queryParams).length === 0) {
                // search with default query params
                return
            }
            const { prs, l, f, t, pid, tg, m, b, cids, nc, d, fids, ...rest }: any = _queryParams
            const newQuery = {
                ...rest
            }
            if (l) {
                newQuery.l = Array.isArray(l) ? [...l] : [l]
                newQuery.newArrivals = Array.isArray(l) ? l.indexOf('new_arrivals') > -1 : false
            }
            if (prs) {
                newQuery.lowRange = prs.split('-')[0].substr(1)
                newQuery.highRange = prs.split('-')[1]
            }
            if (f) {
                setPageNo(f)
            }
            if (pid) {
                newQuery.pid = Array.isArray(pid) ? [...pid] : [pid]
            }
            if (tg) {
                newQuery.tg = Array.isArray(tg) ? [...tg] : [tg]
            }
            if (m) {
                newQuery.m = Array.isArray(m) ? [...m] : [m]
            }
            if (b) {
                newQuery.b = Array.isArray(b) ? [...b] : [b]
            }
            if (cids) {
                newQuery.cids = Array.isArray(cids) ? [...cids] : [cids]
            }
            if (fids) {
                newQuery.fids = Array.isArray(fids) ? [...fids] : [fids]
            }
            if (nc) {
                newQuery.nc = true
            }
            if (d) {
                newQuery.d = true
            }
            invalidate.current = false
            setQueryParams(newQuery)
        }
    }

    const changeQuery = (name, value) => {
        invalidate.current = false
        setQueryParams({
            ...queryParams,
            [name]: value,
        })
    }

    const changeQueryParams = (params: { [key: string]: any }) => {
        invalidate.current = false
        if (params && Object.keys(params).length) {
            setQueryParams({
                ...queryParams,
                ...params,
            })
        }
    }

    const setArrivals = (e) => {
        invalidate.current = false
        const clonedQueryParams = { ...queryParams }
        if (e.target.checked) {
            clonedQueryParams.newArrivals = true
            if (!clonedQueryParams.l) {
                clonedQueryParams.l = []
            } else {
                clonedQueryParams.l = [...clonedQueryParams.l]
            }
            if (clonedQueryParams.l.indexOf('new_arrivals') === -1) {
                clonedQueryParams.l.push('new_arrivals')
            }
        } else {
            clonedQueryParams.newArrivals = false
            if (clonedQueryParams.l && clonedQueryParams.l.indexOf('new_arrivals') !== -1) {
                clonedQueryParams.l = [...clonedQueryParams.l]
                const i = clonedQueryParams.l.indexOf('new_arrivals')
                clonedQueryParams.l.splice(i, 1)
            }
        }
        setQueryParams(clonedQueryParams)
    }

    const downloadData = (data) => {
        const file = new Blob(["\ufeff" + data], { type: 'text/plain;charset=gb2312;' })
        if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(file, 'productList.csv')
        } else {
            const a = document.createElement('a')
            const url = URL.createObjectURL(file)
            a.href = url
            a.download = 'productList.csv'
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url)
            }, 0)
        }
    }

    const toDownload = () => {
        const params = getParams(queryParams, true)
        discoverV2Download(params).then(res => {
            downloadData(res.data)
        })
    }

    useEffect(() => {
        initParams()
        if (!divRef.current) {
            divRef.current = document.createElement('div')
            document.querySelector('.App')?.appendChild(divRef.current)
        }
        return () => {
            divRef.current?.remove()
            abortHandler?.current?.cancel()
        }
    }, [])

    useEffect(() => {
        function onPageSroll(e) {
            const stop = (e?.target as any)?.scrollTop || 0
            if (stop > 108 && !showSearchParams) {
                setShowSearchParams(true)
            } else if (stop < 88 && showSearchParams){
                setShowSearchParams(false)
            }
        }
        const primaryLayout = document.querySelector('#primaryLayout')
        primaryLayout?.addEventListener('scroll', onPageSroll)
        return () => {
            primaryLayout?.removeEventListener('scroll', onPageSroll)
        }
    }, [showSearchParams])

    useEffect(() => {
        if (!invalidate.current) {
            invalidate.current = true
            return
        }
        searchProduct(queryParams)
    }, [pageNo, pageSize, queryParams])

    const pageChange = (page, pageSize) => {
        setPageSize(pageSize)
        setPageNo(page)
    }

    const copySearchLink = () => {
        const params = qs.stringify(getParams(queryParams), { arrayFormat: 'repeat' })
        const copyLink = `https://curators.bybieyang.com/discover?${params}`
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', copyLink)
        input.select()
        // todo deprecated function call
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          message.success(`copy success: ${copyLink}`)
        }
        document.body.removeChild(input)
        updateUrlHistory(params)
    }

    const renderSearchParams = () => {
        if (!showSearchParams || !Object.keys(queryParams).length) return null
        const availParams = ['pid', 'n', 'tg', 'l', 's', 'm', 'b', 'cids']
        let shouldShow = availParams.findIndex(p => queryParams[p] && queryParams[p].length) !== -1
        if (!shouldShow) return null
        return (
            <div className='header-search-params'>
                {
                    Object.keys(queryParams).map((key) => {
                        // only show partial keys
                        if (availParams.indexOf(key) === -1) return null
                        let type = ''
                        switch (key) {
                            case 'm':
                                type = 'Merchant'
                                break
                            case 'b':
                                type = 'Brand'
                                break
                            case 'cids':
                                type = 'Category'
                                break
                            case 'pid':
                                type = 'Product Id'
                                break
                            case 'n':
                                type = 'query'
                                break
                            case 'tg':
                                type = 'Tag'
                                break
                            case 'l':
                                type = 'label'
                                break
                            case 's':
                                type = 'Sort'
                                break
                            default:
                                break
                        }
                        const value = Array.isArray(queryParams[key]) ? queryParams[key].join(', ') : queryParams[key]
                        if (!value || !value.length) return null
                        return (
                            <div key={key} className='header-search-params-item'>
                                <span className='params-item-key'>{type}:</span>
                                <span className='params-item-value'>{value}</span>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const { pid, tg, l, n, m, b, nc, oos, d, cids, newArrivals, lowRange, highRange, s, fids } = queryParams || {}
    const sortValue = sortOptions.findIndex(o => o.value.sortKey === s)

    return (
        <>
            <Form
                style={{
                    background: '#f8f9fa'
                }}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
            >
                <Row>
                    <Col span={6}>
                        <Form.Item label="Merchant">
                            <MerchantSelect
                                showCategory
                                mode='multiple'
                                placeholder="Please select merchant"
                                value={m}
                                style={{width: 200}}
                                onChange={(e) => changeQuery('m', e)} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Brand">
                            <BrandSelect
                                mode="multiple"
                                placeholder="Please select brand"
                                value={b}
                                onChange={(e) => changeQuery('b', e)} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Category">
                            <TreeSelect
                                showSearch
                                value={cids || []}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                placeholder="Please select"
                                allowClear
                                multiple
                                style={{width: 200}}
                                treeNodeFilterProp="title"
                                onChange={(val) => changeQuery('cids', val)}
                            >
                                {Categories && Categories.category && treeSelect(Categories.children)}
                            </TreeSelect>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Product Id">
                            <Select
                                mode="tags"
                                placeholder="search by Product Id"
                                style={{width: 200}}
                                value={pid || []}
                                onChange={e => changeQuery('pid', e)}>
                                {
                                    pid?.map(item => <Option key={item} value={item}>{item}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Query">
                            <Input
                                placeholder="比如:HYDRA BEAUTY Micro Sérum"
                                value={n}
                                style={{width: 200}}
                                onChange={e => changeQuery('n', e.target.value)}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Tag">
                            <Select
                                mode="tags"
                                placeholder="search by tags"
                                value={tg}
                                style={{width: 200}}
                                onChange={e => changeQuery('tg', e)}>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Label">
                            <Select
                                mode="tags"
                                style={{width: 200}}
                                placeholder="search by labels"
                                value={l}
                                onChange={e => changeQuery('l', e)}>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Range($)">
                            <>
                                <InputNumber
                                    min={0}
                                    value={lowRange / 100 || undefined}
                                    formatter={value =>
                                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                    parser={value =>
                                        value != undefined ? +value.replace(/\$\s?|(,*)/g, '') : Number.NaN
                                    }
                                    onChange={val => changeQuery('lowRange', val * 100)}
                                />
                                -
                                <InputNumber
                                    value={highRange / 100 || undefined}
                                    formatter={value =>
                                        `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                    parser={value =>
                                        value != undefined ? +value.replace(/\$\s?|(,*)/g, '') : Number.NaN
                                    }
                                    onChange={val => changeQuery('highRange', val * 100)}
                                />
                            </>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Sort">
                            <Select
                                style={{width: 200}}
                                placeholder="Please select factors"
                                value={sortValue === -1 ? undefined : sortValue}
                                allowClear
                                onChange={e => {
                                    changeQueryParams({
                                        's': e === undefined ? undefined : sortOptions[e].value.sortKey,
                                        'asc': e === undefined ? undefined : !!sortOptions[e].value.ascending
                                    })
                                }}
                            >
                                {
                                    sortOptions.map((option, index) => (
                                        <Option key={index} value={index}>{option.label}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Attributes">
                            <AttributeValueSelect
                                ids={getAggregationsFeatureIds(searchResult?.aggregations)}
                                style={{ width: 200 }}
                                placeholder="Please select attributes"
                                value={fids}
                                allowClear
                                showSearch
                                onChange={e => {
                                    changeQuery('fids', e)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row align="middle" justify="space-between" style={{ textAlign: 'left', paddingRight: 15, height: 40 }}>
                    <Col span={12}>
                        <Checkbox style={{ height: 40, lineHeight: '40px' }} checked={nc} onChange={e => changeQuery('nc', e.target.checked)}>Bypass Cache</Checkbox>
                        <Checkbox checked={oos} onChange={e => changeQuery('oos', e.target.checked)}>Include sold out</Checkbox>
                        <Checkbox checked={d} onChange={e => changeQuery('d', e.target.checked)}>Show detail</Checkbox>
                        <Checkbox checked={newArrivals} onChange={setArrivals}>New Arrivals</Checkbox>
                    </Col>
                    <Col span={12} style={{ textAlign:'right' }}>
                        <Switch checkedChildren="完整" unCheckedChildren="缩略" onClick={setExpandFlag} />
                        <Button
                            style={{ marginLeft: 20 }}
                            onClick={() => {
                                invalidate.current = false
                                setQueryParams({})
                                const params = getParams({})
                                updateUrlHistory(qs.stringify(params, { arrayFormat: 'repeat' }))
                            }}
                        >Reset</Button>
                        <Button
                            type='primary'
                            style={{ marginLeft: 20 }}
                            onClick={() => {
                                setPageNo(1)
                                setQueryParams({ ...queryParams })
                                const params = getParams(queryParams)
                                updateUrlHistory(qs.stringify(params, { arrayFormat: 'repeat' }))
                            }}
                        >
                            Kick Off
                        </Button>
                        <Button 
                            style={{ marginLeft: 20 }}
                            onClick={() => setShowModal(true)}>Download</Button>
                        <Button 
                            style={{ marginLeft: 20 }}
                            type='primary'
                            name='copyLink'
                            onClick={copySearchLink}>
                                Share
                        </Button>
                    </Col>
                </Row>
            </Form>
            
            <Modal
                title="下载CSV"
                visible={showModal}
                onOk={toDownload}
                onCancel={() => setShowModal(false)}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                >
                    <Form.Item label="Product ID only">
                        <Checkbox checked={onlyProduct} onChange={e => setOnlyProduct(e.target.checked)}>only search productId</Checkbox>
                    </Form.Item>
                    <Form.Item label="Product Count">
                        <Select onChange={setLimit} value={limit}>
                            {[1000, 2000, 3000, 4000, 5000].map(v => <Option value={v} key={v}>{v}</Option>)}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
            {
                divRef.current && ReactDOM.createPortal(
                    <div className="fixPagenation search-form-paginator">
                        <Pagination current={+pageNo || 1} total={searchResult?.total || 0} pageSize={pageSize} showQuickJumper showTotal={total => `Total:${total}`} onChange={pageChange}></Pagination>
                    </div>,
                    divRef.current
                )
            }        
            {renderSearchParams()}      
        </>
    )
}

const mapStateToProps = (state) => ({
    Categories: state.categories.categoryTree,
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm)
